// Referee details interface

import { useState, useEffect } from 'react';
import UserCardTemplate from './UserCardTemplate';
import PropItem from './PropItem';
import PropItemsBlock from './PropItemsBlock';
import RefereeCardEdit from './RefereeCardEdit';
import TournamentsList from './TournamentsList';
import RefereeInvitations from './RefereeInvitations';
import RefereePayouts from './RefereePayouts';
import GuidedTour from './GuidedTour';
import { useFirebase } from './FirebaseContextProvider';
import placeholderPerson from '../assets/images/placeholder-person.png';

const steps = [
  {
    target: '.tabs-header-item-tournaments',
    title: 'Your tournaments',
    content: 'Here are the tournaments you are assigned to referee',
  },
  {
    target: '.tabs-header-item-profile',
    title: 'Your profile',
    content: 'Your profile lives here — edit your info and contact details',
  },
];

export default function RefereeCard({ referee }) {
  const [run, setRun] = useState(false);
  const { user, userIsAdmin, userIsReferee } = useFirebase();

  const { id, name, phone, email } = referee;


  const isTheUser = user?.id === id;

  useEffect(() => {
    if (user.name) setRun(true);
  }, [user.name]);

  return (
    <GuidedTour
      steps={userIsReferee ? steps : []}
      run={run}
      tourKey='referee-card-v1'
    >
      <UserCardTemplate
        header='Referee'
        className='referee-card'
        backBtn={!isTheUser}
        isTheUser={isTheUser}
        imgPath={referee.imgPath}
        imgThumbPath={referee.imgThumbPath}
        imgTitle={name}
        name={name}
        placeholder={placeholderPerson}
        details={
          <PropItemsBlock>
            <PropItem prop='Phone' value={phone} />
            <PropItem prop='e-mail' value={email} />
          </PropItemsBlock>
        }
        editForm={
          (userIsAdmin || isTheUser) && <RefereeCardEdit referee={referee} />
        }
        tabs={[
          {
            title: 'Tournaments',
            hash: '#tournaments',
            component: (
              <>
                {isTheUser && <RefereeInvitations />}
                <TournamentsList refereeId={id} />
              </>
            ),
          },
          // Their own money only: the rules prove the read through their uid
          ...(isTheUser
            ? [
                {
                  title: 'Payouts',
                  hash: '#payouts',
                  component: <RefereePayouts refereeId={id} />,
                },
              ]
            : []),
        ]}
      />
    </GuidedTour>
  );
}
